import {Form, message} from 'antd';
import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useHistory, useRouteMatch} from 'react-router';
import ActionBar from '../../../../components/action-bar';
import ActionButton from '../../../../components/action-button';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import useLoading from '../../../../hooks/useLoading';
import { fetchDocumentos, fetchLicencas, fetchUnidade, fetchUnidades, unidadeSelector } from '../../../../store/empresa';
import unwrapAxiosPromise from '../../../../util/unwrapAxiosPromise';
import EmpresaUnidadeForm from './_form';
import useModulo from "../../../../hooks/useModulo";

export default function EmpresaUnidadeEditPage() {
  const {t} = useTranslation();
  const dispatch = useDispatchWithResult();
  const [form] = Form.useForm();
  const unidade = useSelector(unidadeSelector);
  const loading = useLoading(fetchUnidade.typePrefix);
  const [loadingSave, setLoadingSave] = useState(false);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;
  const {moduloBasePath} = useModulo();

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(unidade);
    setImmediate(() => document.querySelector('#apelido').focus());
  }, [unidade]);

  const handleFinish = values => {
    setLoadingSave(true);
    unwrapAxiosPromise(axios.put(`/empresas/${empresaId}/unidades/${id}`, values), form)
        .then(() => {
          message.success(t('Registro alterado com sucesso'));
          history.replace(`${moduloBasePath}/empresas/${empresaId}/unidades/${id}`);
          dispatch(fetchUnidades({empresaId}));
          dispatch(fetchUnidade({empresaId, id}));
          dispatch(fetchLicencas({empresaId}));
          dispatch(fetchDocumentos({ empresaId }));
        })
        .finally(() => setLoadingSave(false));
  };

  const handleCancel = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/unidades/${id}`);
  };

  const title = (
      <ActionBar>
        <ActionButton.Save onClick={form.submit} loading={loadingSave} />
        <ActionButton.Cancel onClick={handleCancel} disabled={loadingSave} />
      </ActionBar>);

  return (
      <EmpresaUnidadeForm
          autoFillByCnpj="normal"
          disabled={loadingSave}
          form={form}
          loading={loading}
          onFinish={handleFinish}
          title={title}
      />);
}
